// extracted by mini-css-extract-plugin
export default {"container":"BlockInfo_container__OAQil","row":"BlockInfo_row__h5Iys","icon":"BlockInfo_icon__uDA-P","label":"BlockInfo_label__2Gq1F","value":"BlockInfo_value__h44wT"};